export const TRANSLATION_KEYS = {
    Heading: "loginPage.heading",
    ButtonText: "loginPage.buttonText",
    LoginProgress: "loginPage.loginProgress"
};